export type HistoryMode = "viewed" | "posted";

export function parseHistoryMode(value: unknown): HistoryMode {
  return value === "posted" ? "posted" : "viewed";
}

export function historyModeLabel(mode: HistoryMode): string {
  return mode === "posted" ? "書込履歴" : "閲覧履歴";
}
